import { useEffect, useMemo, useState } from "react";

export interface KeyboardShortcutProps {
  /** ショートカットの種類 */
  shortcut: "run" | "submit" | "save" | "search";
  /** カスタムクラス */
  className?: string;
}

// Mac判定用のフック
export function useIsMac(): boolean {
  // The initial value must match SSR on Linux/Windows browsers. Detecting the
  // platform during the first browser render changed ⌘↵ into Ctrl+Enter before
  // hydration and produced React error #418.
  const [isMac, setIsMac] = useState(true);
  useEffect(() => {
    setIsMac(navigator.platform.toUpperCase().includes("MAC"));
  }, []);
  return isMac;
}

// ショートカットキーの定義
const SHORTCUTS = {
  run: {
    mac: "⌘↵",
    windows: "Ctrl+Enter",
  },
  submit: {
    mac: "⌘⇧↵",
    windows: "Ctrl+Shift+Enter",
  },
  save: {
    mac: "⌘S",
    windows: "Ctrl+S",
  },
  search: {
    mac: "⌘K",
    windows: "Ctrl+K",
  },
} as const;

export function KeyboardShortcut({
  shortcut,
  className = "",
}: KeyboardShortcutProps) {
  const isMac = useIsMac();

  const shortcutText = useMemo(() => {
    return isMac ? SHORTCUTS[shortcut].mac : SHORTCUTS[shortcut].windows;
  }, [isMac, shortcut]);

  return (
    <span
      className={`hidden sm:[@media(hover:hover)_and_(pointer:fine)]:inline font-sans text-xs font-normal leading-none text-sub opacity-70 ${className}`}
    >
      {shortcutText}
    </span>
  );
}

// ショートカットテキストを取得するユーティリティ関数
export function getShortcutText(
  shortcut: keyof typeof SHORTCUTS,
  isMac?: boolean
): string {
  const isMacPlatform =
    isMac ?? true;
  return isMacPlatform ? SHORTCUTS[shortcut].mac : SHORTCUTS[shortcut].windows;
}
